var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M.667 3h14.666v10H.667V3Z","fill":"#DD2C00"}}),_c('path',{attrs:{"d":"M.667 5.667h14.666v4.666H.667V5.667Z","fill":"#FFC107"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }